// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
:host {
  display: flex;
  flex-direction: row;
}
:host .default {
  color: #a5a7b6;
}
:host .disable {
  color: #c4c5cf;
}
:host .error {
  color: #e40c3e;
}
:host .link {
  color: #005c77;
}
:host .linkHover {
  color: #003747;
}
:host .primary {
  color: #151519;
}
:host .secondary {
  color: #ffffff;
}
:host .secondaryDisable {
  color: #c4c5cf;
}
:host .tertiary {
  color: #005c77;
}
:host .accentBlue {
  color: #003747;
}
:host .accentGreen {
  color: #198042;
}
:host .accentGrey {
  color: #40424f;
}
:host .accentOrange {
  color: #c21d00;
}
:host .accentPurple {
  color: #3d228b;
}
:host .accentRed {
  color: #bc061b;
}
:host .accentYellow {
  color: #8a6c00;
}
:host .buttonLink {
  color: #005c77;
}
:host .buttonLinkHover {
  color: #003747;
}
:host .buttonNormal {
  color: #151519;
}
:host .buttonPrimaryDisabled {
  color: #c4c5cf;
}
:host .buttonSecondaryDisable {
  color: #c4c5cf;
}
:host .buttonSecondaryNormal {
  color: #ffffff;
}
:host .statNegative {
  color: #f53864;
}
:host .statPositive {
  color: #22aa58;
}
:host .statWarning {
  color: #8a6c00;
}
:host .auto {
  cursor: auto;
}
:host .default {
  cursor: default;
}
:host .pointer {
  cursor: pointer;
}
:host .crosshair {
  cursor: crosshair;
}
:host .move {
  cursor: move;
}
:host .text {
  cursor: text;
}
:host .wait {
  cursor: wait;
}
:host .help {
  cursor: help;
}
:host .progress {
  cursor: progress;
}
:host .not-allowed {
  cursor: not-allowed;
}
:host .underline {
  text-decoration: underline;
}
:host .lineThrough {
  text-decoration: line-through;
}

@supports (-webkit-line-clamp: 1) {
  .lnOne {
    display: block;
    display: -webkit-box !important;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
  }
}
@supports not (-webkit-line-clamp: 1) {
  .lnOne {
    position: relative;
    overflow: hidden;
    width: 100%;
    word-break: break-all;
  }
  .lnOne:before {
    content: "        ";
    position: absolute;
    bottom: 0;
    right: 0;
  }
}

@supports (-webkit-line-clamp: 2) {
  .lnTwo {
    display: block;
    display: -webkit-box !important;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
  }
}
@supports not (-webkit-line-clamp: 2) {
  .lnTwo {
    position: relative;
    overflow: hidden;
    width: 100%;
    word-break: break-all;
  }
  .lnTwo:before {
    content: "        ";
    position: absolute;
    bottom: 0;
    right: 0;
  }
}

@supports (-webkit-line-clamp: 3) {
  .lnThree {
    display: block;
    display: -webkit-box !important;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
  }
}
@supports not (-webkit-line-clamp: 3) {
  .lnThree {
    position: relative;
    overflow: hidden;
    width: 100%;
    word-break: break-all;
  }
  .lnThree:before {
    content: "        ";
    position: absolute;
    bottom: 0;
    right: 0;
  }
}

@supports (-webkit-line-clamp: 4) {
  .lnFour {
    display: block;
    display: -webkit-box !important;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
  }
}
@supports not (-webkit-line-clamp: 4) {
  .lnFour {
    position: relative;
    overflow: hidden;
    width: 100%;
    word-break: break-all;
  }
  .lnFour:before {
    content: "        ";
    position: absolute;
    bottom: 0;
    right: 0;
  }
}

@supports (-webkit-line-clamp: 5) {
  .lnFive {
    display: block;
    display: -webkit-box !important;
    -webkit-line-clamp: 5;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
  }
}
@supports not (-webkit-line-clamp: 5) {
  .lnFive {
    position: relative;
    overflow: hidden;
    width: 100%;
    word-break: break-all;
  }
  .lnFive:before {
    content: "        ";
    position: absolute;
    bottom: 0;
    right: 0;
  }
}

@supports (-webkit-line-clamp: 6) {
  .lnSix {
    display: block;
    display: -webkit-box !important;
    -webkit-line-clamp: 6;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
  }
}
@supports not (-webkit-line-clamp: 6) {
  .lnSix {
    position: relative;
    overflow: hidden;
    width: 100%;
    word-break: break-all;
  }
  .lnSix:before {
    content: "        ";
    position: absolute;
    bottom: 0;
    right: 0;
  }
}

@supports (-webkit-line-clamp: 7) {
  .lnSeven {
    display: block;
    display: -webkit-box !important;
    -webkit-line-clamp: 7;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
  }
}
@supports not (-webkit-line-clamp: 7) {
  .lnSeven {
    position: relative;
    overflow: hidden;
    width: 100%;
    word-break: break-all;
  }
  .lnSeven:before {
    content: "        ";
    position: absolute;
    bottom: 0;
    right: 0;
  }
}

@supports (-webkit-line-clamp: 8) {
  .lnEight {
    display: block;
    display: -webkit-box !important;
    -webkit-line-clamp: 8;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
  }
}
@supports not (-webkit-line-clamp: 8) {
  .lnEight {
    position: relative;
    overflow: hidden;
    width: 100%;
    word-break: break-all;
  }
  .lnEight:before {
    content: "        ";
    position: absolute;
    bottom: 0;
    right: 0;
  }
}

@supports (-webkit-line-clamp: 9) {
  .lnNine {
    display: block;
    display: -webkit-box !important;
    -webkit-line-clamp: 9;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
  }
}
@supports not (-webkit-line-clamp: 9) {
  .lnNine {
    position: relative;
    overflow: hidden;
    width: 100%;
    word-break: break-all;
  }
  .lnNine:before {
    content: "        ";
    position: absolute;
    bottom: 0;
    right: 0;
  }
}

@supports (-webkit-line-clamp: 10) {
  .lnTen {
    display: block;
    display: -webkit-box !important;
    -webkit-line-clamp: 10;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
  }
}
@supports not (-webkit-line-clamp: 10) {
  .lnTen {
    position: relative;
    overflow: hidden;
    width: 100%;
    word-break: break-all;
  }
  .lnTen:before {
    content: "        ";
    position: absolute;
    bottom: 0;
    right: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/_text-configurations.scss","webpack://./src/styles/_displayed.scss","webpack://./src/styles/_colors.scss","webpack://./src/styles/_font.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAIhB;ECUE,aAAA;EAKA,mBAAA;ADfF;AAIE;EACE,cE2MiB;AF7MrB;AAKE;EACE,cEwMiB;AF3MrB;AAME;EACE,cEqMe;AFzMnB;AAOE;EACE,cEkMc;AFvMlB;AAQE;EACE,cE+LoB;AFrMxB;AASE;EACE,cE4LiB;AFnMrB;AAUE;EACE,cEyLmB;AFjMvB;AAWE;EACE,cEsL2B;AF/L/B;AAYE;EACE,cEmLkB;AF7LtB;AAaE;EACE,cEgLqB;AF3LzB;AAcE;EACE,cE6KsB;AFzL1B;AAeE;EACE,cE0KqB;AFvLzB;AAgBE;EACE,cEuKuB;AFrL3B;AAiBE;EACE,cEoKuB;AFnL3B;AAkBE;EACE,cEiKoB;AFjLxB;AAmBE;EACE,cE8JuB;AF/K3B;AAoBE;EACE,cE2JqB;AF7KzB;AAqBE;EACE,cEwJ2B;AF3K/B;AAsBE;EACE,cEsJ+B;AF1KnC;AAuBE;EACE,cEiJiC;AFtKrC;AAwBE;EACE,cE+IkC;AFrKtC;AAyBE;EACE,cE4IiC;AFnKrC;AA0BE;EACE,cEyIuB;AFjK3B;AA2BE;EACE,cEsIuB;AF/J3B;AA4BE;EACE,cEmIsB;AF7J1B;AA+BE;EACE,YAAA;AA7BJ;AAgCE;EACE,eAAA;AA9BJ;AAiCE;EACE,eAAA;AA/BJ;AAkCE;EACE,iBAAA;AAhCJ;AAmCE;EACE,YAAA;AAjCJ;AAoCE;EACE,YAAA;AAlCJ;AAqCE;EACE,YAAA;AAnCJ;AAsCE;EACE,YAAA;AApCJ;AAuCE;EACE,gBAAA;AArCJ;AAwCE;EACE,mBAAA;AAtCJ;AAyCE;EACE,0BAAA;AAvCJ;AA0CE;EACE,6BAAA;AAxCJ;;AGXE;EHuDF;IGtDI,cAAA;IACA,+BAAA;IAGA,qBHmDwC;IGlDxC,4BAAA;IACA,gBAAA;IACA,uBAAA;IACA,qBAAA;EHaF;AACF;AGZE;EH4CF;IG3CI,kBAAA;IAGA,gBAAA;IACA,WAAA;IACA,qBAAA;EHaF;EGZE;IACE,mBAAA;IACA,kBAAA;IACA,SAAA;IACA,QAAA;EHcJ;AACF;;AGrCE;EH2DF;IG1DI,cAAA;IACA,+BAAA;IAGA,qBHuDwC;IGtDxC,4BAAA;IACA,gBAAA;IACA,uBAAA;IACA,qBAAA;EHuCF;AACF;AGtCE;EHgDF;IG/CI,kBAAA;IAGA,gBAAA;IACA,WAAA;IACA,qBAAA;EHuCF;EGtCE;IACE,mBAAA;IACA,kBAAA;IACA,SAAA;IACA,QAAA;EHwCJ;AACF;;AG/DE;EH+DF;IG9DI,cAAA;IACA,+BAAA;IAGA,qBH2DwC;IG1DxC,4BAAA;IACA,gBAAA;IACA,uBAAA;IACA,qBAAA;EHiEF;AACF;AGhEE;EHoDF;IGnDI,kBAAA;IAGA,gBAAA;IACA,WAAA;IACA,qBAAA;EHiEF;EGhEE;IACE,mBAAA;IACA,kBAAA;IACA,SAAA;IACA,QAAA;EHkEJ;AACF;;AGzFE;EHmEF;IGlEI,cAAA;IACA,+BAAA;IAGA,qBH+DwC;IG9DxC,4BAAA;IACA,gBAAA;IACA,uBAAA;IACA,qBAAA;EH2FF;AACF;AG1FE;EHwDF;IGvDI,kBAAA;IAGA,gBAAA;IACA,WAAA;IACA,qBAAA;EH2FF;EG1FE;IACE,mBAAA;IACA,kBAAA;IACA,SAAA;IACA,QAAA;EH4FJ;AACF;;AGnHE;EHuEF;IGtEI,cAAA;IACA,+BAAA;IAGA,qBHmEwC;IGlExC,4BAAA;IACA,gBAAA;IACA,uBAAA;IACA,qBAAA;EHqHF;AACF;AGpHE;EH4DF;IG3DI,kBAAA;IAGA,gBAAA;IACA,WAAA;IACA,qBAAA;EHqHF;EGpHE;IACE,mBAAA;IACA,kBAAA;IACA,SAAA;IACA,QAAA;EHsHJ;AACF;;AG7IE;EH2EF;IG1EI,cAAA;IACA,+BAAA;IAGA,qBHuEwC;IGtExC,4BAAA;IACA,gBAAA;IACA,uBAAA;IACA,qBAAA;EH+IF;AACF;AG9IE;EHgEF;IG/DI,kBAAA;IAGA,gBAAA;IACA,WAAA;IACA,qBAAA;EH+IF;EG9IE;IACE,mBAAA;IACA,kBAAA;IACA,SAAA;IACA,QAAA;EHgJJ;AACF;;AGvKE;EH+EF;IG9EI,cAAA;IACA,+BAAA;IAGA,qBH2EwC;IG1ExC,4BAAA;IACA,gBAAA;IACA,uBAAA;IACA,qBAAA;EHyKF;AACF;AGxKE;EHoEF;IGnEI,kBAAA;IAGA,gBAAA;IACA,WAAA;IACA,qBAAA;EHyKF;EGxKE;IACE,mBAAA;IACA,kBAAA;IACA,SAAA;IACA,QAAA;EH0KJ;AACF;;AGjME;EHmFF;IGlFI,cAAA;IACA,+BAAA;IAGA,qBH+EwC;IG9ExC,4BAAA;IACA,gBAAA;IACA,uBAAA;IACA,qBAAA;EHmMF;AACF;AGlME;EHwEF;IGvEI,kBAAA;IAGA,gBAAA;IACA,WAAA;IACA,qBAAA;EHmMF;EGlME;IACE,mBAAA;IACA,kBAAA;IACA,SAAA;IACA,QAAA;EHoMJ;AACF;;AG3NE;EHuFF;IGtFI,cAAA;IACA,+BAAA;IAGA,qBHmFwC;IGlFxC,4BAAA;IACA,gBAAA;IACA,uBAAA;IACA,qBAAA;EH6NF;AACF;AG5NE;EH4EF;IG3EI,kBAAA;IAGA,gBAAA;IACA,WAAA;IACA,qBAAA;EH6NF;EG5NE;IACE,mBAAA;IACA,kBAAA;IACA,SAAA;IACA,QAAA;EH8NJ;AACF;;AGrPE;EH2FF;IG1FI,cAAA;IACA,+BAAA;IAGA,sBHuFwC;IGtFxC,4BAAA;IACA,gBAAA;IACA,uBAAA;IACA,qBAAA;EHuPF;AACF;AGtPE;EHgFF;IG/EI,kBAAA;IAGA,gBAAA;IACA,WAAA;IACA,qBAAA;EHuPF;EGtPE;IACE,mBAAA;IACA,kBAAA;IACA,SAAA;IACA,QAAA;EHwPJ;AACF","sourcesContent":["@use 'font' as f;\n@use 'colors' as c;\n@use 'displayed' as d;\n\n:host {\n  @include d.flex-row;\n\n  //DOCS: Font colors\n  .default {\n    color: c.$color-text-default ;\n  }\n\n  .disable {\n    color: c.$color-text-disable ;\n  }\n\n  .error {\n    color: c.$color-text-error ;\n  }\n\n  .link {\n    color: c.$color-text-link ;\n  }\n\n  .linkHover {\n    color: c.$color-text-link-hover ;\n  }\n\n  .primary {\n    color: c.$color-text-primary ;\n  }\n\n  .secondary {\n    color: c.$color-text-secondary ;\n  }\n\n  .secondaryDisable {\n    color: c.$color-text-secondary-disable ;\n  }\n\n  .tertiary {\n    color: c.$color-text-tertiary ;\n  }\n\n  .accentBlue {\n    color: c.$color-text-accent-blue;\n  }\n\n  .accentGreen {\n    color: c.$color-text-accent-green ;\n  }\n\n  .accentGrey {\n    color: c.$color-text-accent-grey;\n  }\n\n  .accentOrange {\n    color: c.$color-text-accent-orange;\n  }\n\n  .accentPurple {\n    color: c.$color-text-accent-purple;\n  }\n\n  .accentRed {\n    color: c.$color-text-accent-red;\n  }\n\n  .accentYellow {\n    color: c.$color-text-accent-yellow;\n  }\n\n  .buttonLink {\n    color: c.$color-text-button-link;\n  }\n\n  .buttonLinkHover {\n    color: c.$color-text-button-link-hover;\n  }\n\n  .buttonNormal {\n    color: c.$color-text-button-primary-normal;\n  }\n\n  .buttonPrimaryDisabled {\n    color: c.$color-text-button-primary-disabled;\n  }\n\n  .buttonSecondaryDisable {\n    color: c.$color-text-button-secondary-disable;\n  }\n\n  .buttonSecondaryNormal {\n    color: c.$color-text-button-secondary-normal ;\n  }\n\n  .statNegative {\n    color: c.$color-text-stat-negative;\n  }\n\n  .statPositive {\n    color: c.$color-text-stat-positive ;\n  }\n\n  .statWarning {\n    color: c.$color-text-stat-warning;\n  }\n\n  //DOCS: Cursor\n\n  .auto {\n    cursor: auto;\n  }\n\n  .default {\n    cursor: default;\n  }\n\n  .pointer {\n    cursor: pointer;\n  }\n\n  .crosshair {\n    cursor: crosshair;\n  }\n\n  .move {\n    cursor: move;\n  }\n\n  .text {\n    cursor: text;\n  }\n\n  .wait {\n    cursor: wait;\n  }\n\n  .help {\n    cursor: help;\n  }\n\n  .progress {\n    cursor: progress;\n  }\n\n  .not-allowed {\n    cursor: not-allowed;\n  }\n\n  .underline {\n    text-decoration: underline;\n  }\n\n  .lineThrough {\n    text-decoration: line-through;\n  }\n}\n\n.lnOne {\n  @include f.multiLineTextTruncateSinHeight(1);\n}\n\n.lnTwo {\n  @include f.multiLineTextTruncateSinHeight(2);\n}\n\n.lnThree {\n  @include f.multiLineTextTruncateSinHeight(3);\n}\n\n.lnFour {\n  @include f.multiLineTextTruncateSinHeight(4);\n}\n\n.lnFive {\n  @include f.multiLineTextTruncateSinHeight(5);\n}\n\n.lnSix {\n  @include f.multiLineTextTruncateSinHeight(6);\n}\n\n.lnSeven {\n  @include f.multiLineTextTruncateSinHeight(7);\n}\n\n.lnEight {\n  @include f.multiLineTextTruncateSinHeight(8);\n}\n\n.lnNine {\n  @include f.multiLineTextTruncateSinHeight(9);\n}\n\n.lnTen {\n  @include f.multiLineTextTruncateSinHeight(10);\n}\n","/// Breakpoints names\n$small: 'small';\n$standard: 'standard';\n\n\n/// Breakpoints\n$breakpoints-pqf: ($small: 0px, $standard: 1920px);\n\n@mixin height-width-100 {\n  height: 100%;\n  width: 100%;\n}\n\n@mixin _flex {\n  display: flex;\n}\n\n@mixin _flex-row {\n  @include _flex;\n  flex-direction: row;\n}\n\n@mixin flex-row-wrap {\n  @include _flex-row;\n  flex-wrap: wrap;\n}\n\n@mixin flex-row {\n  @include _flex-row;\n}\n\n@mixin flex-column {\n  @include _flex;\n  flex-direction: column;\n}\n\n@mixin flex-center-items {\n  align-items: center;\n  justify-content: center;\n}\n\n// MediaQuery\n$small-screen: 1366px;\n$medium-screen: 1920px;\n$large-screen: 2560px;\n\n@mixin custom-media-query($size) {\n  @media (min-width: $size) {\n    @content;\n  }\n}\n","@use 'sass:map';\n\n$_blue: (\n  '50': #d6f5ff,\n  '100': #b3edff,\n  '200': #61daff,\n  '300': #14c8ff,\n  '400': #0098c7,\n  '500': #005c77,\n  '600': #004a61,\n  '700': #003747,\n  '800': #00232e,\n  '900': #001419,\n);\n\n$_green: (\n  '50': #eafbf1,\n  '100': #d4f7e2,\n  '200': #aaeec5,\n  '300': #7fe6a8,\n  '400': #55dd8b,\n  '500': #2dd570,\n  '600': #22aa58,\n  '700': #198042,\n  '800': #11552c,\n  '900': #082b16,\n);\n\n$_grayscale: (\n  '50': #f1f1f4,\n  '100': #e0e1e6,\n  '200': #c4c5cf,\n  '300': #a5a7b6,\n  '400': #898c9f,\n  '500': #6c6f84,\n  '600': #57596b,\n  '700': #40424f,\n  '800': #2c2d35,\n  '900': #151519,\n);\n\n$_purple: (\n  '50': #f2effb,\n  '100': #e1daf6,\n  '200': #c7b9ee,\n  '300': #a995e5,\n  '400': #8b70dc,\n  '500': #6f4dd3,\n  '600': #502db8,\n  '700': #3d228b,\n  '800': #29175e,\n  '900': #140b2d,\n);\n\n$_red: (\n  '50': #feecf0,\n  '100': #fdd8e1,\n  '200': #fbb1c3,\n  '300': #f986a1,\n  '400': #f75f82,\n  '500': #f53864,\n  '600': #e40c3e,\n  '700': #bc061b,\n  '800': #750620,\n  '900': #3a0310,\n);\n\n$_white: (\n  '50': #ffffff0d,\n  '100': #ffffff1a,\n  '200': #ffffff33,\n  '300': #ffffff4d,\n  '400': #ffffff66,\n  '500': #ffffff80,\n  '600': #ffffff99,\n  '700': #ffffffcc,\n  '800': #ffffffe5,\n  '900': #ffffff,\n);\n\n$_yellow: (\n  '50': #fffcf0,\n  '100': #fff7db,\n  '200': #fff1bd,\n  '300': #ffe999,\n  '400': #ffe175,\n  '500': #ffd953,\n  '600': #ffcb0f,\n  '700': #cca000,\n  '800': #8a6c00,\n  '900': #423400,\n);\n\n$_orange: (\n'50': #ffeeeb,\n'100': #ffe1db,\n'200': #ffc2b8,\n'300': #ffa08f,\n'400': #ff816b,\n'500': #ff6348,\n'600': #ff2b05,\n'700': #c21d00,\n'800': #851400,\n'900': #420a00,\n);\n\n$color-background-blue: #004a61e5;\n$color-background-header: map.get($_blue, '500');\n$color-background-accent-blue: map.get($_blue, '50');\n$color-background-accent-green: map.get($_green, '50');\n$color-background-accent-grey: map.get($_grayscale, '50');\n$color-background-accent-orange: map.get($_orange, '50');\n$color-background-accent-purple: map.get($_purple, '50');\n$color-background-accent-red: map.get($_red, '50');\n$color-background-accent-yellow: map.get($_yellow, '50');\n$color-background-button-destructive-active: map.get($_red, '800');\n$color-background-button-destructive-disable: map.get($_red, '200');\n$color-background-button-destructive-hover: map.get($_red, '700');\n$color-background-button-destructive-normal: map.get($_red, '600');\n$color-background-button-primary-active: map.get($_blue, '700');\n$color-background-button-primary-disable: map.get($_grayscale, '50');\n$color-background-button-primary-hover: map.get($_blue, '600');\n$color-background-button-primary-normal: map.get($_blue, '500');\n$color-background-button-secondary-active: map.get($_white, '900');\n$color-background-button-secondary-disable: map.get($_white, '900');\n$color-background-button-secondary-hover: map.get($_grayscale, '50');\n$color-background-button-secondary-normal: map.get($_white, '900');\n$color-background-card-alert: map.get($_red, '600');\n$color-background-card-blue: map.get($_blue, '600');\n$color-background-card-disable: map.get($_grayscale, '100');\n$color-background-card-green: map.get($_green, '600');\n$color-background-card-white: map.get($_white, '900');\n$color-background-card-yellow: map.get($_yellow, '600');\n$color-background-checkbox-checked: map-get($_blue, '500');\n$color-background-checkbox-disabled: map-get($_grayscale, '50');\n$color-background-checkbox-hover: map-get($_blue, '600');\n$color-background-checkbox-normal: map-get($_white, '900');\n$color-background-chip-blue: map-get($_blue, '500');\n$color-background-chip-green: map-get($_green, '500');\n$color-background-chip-orange: map-get($_orange, '500');\n$color-background-chip-purple: map-get($_purple, '500');\n$color-background-chip-red: map-get($_red, '500');\n$color-background-chip-yellow: map-get($_yellow, '500');\n$color-background-input-disable: map-get($_grayscale, '50');\n$color-background-input-hover: map-get($_grayscale, '50');\n$color-background-input-normal: map-get($_white, '900');\n$color-background-tooltip-normal: map-get($_blue, '600');\n$color-background-modal: map.get($_grayscale, '600');\n$color-border-accent-blue: map.get($_blue, '500');\n$color-border-accent-gray: map.get($_grayscale, '300');\n$color-border-accent-green: map.get($_green, '300');\n$color-border-accent-orange: map.get($_orange, '300');\n$color-border-accent-purple: map.get($_purple, '300');\n$color-border-accent-red: map.get($_red, '300');\n$color-border-accent-yellow: map.get($_yellow, '700');\n$color-border-button-default: map.get($_grayscale, '200');\n$color-border-button-disable: map.get($_grayscale, '100');\n$color-border-button-hover: map.get($_grayscale, '300');\n$color-border-button-select: map.get($_grayscale, '400');\n$color-border-checkbox-disable: map.get($_grayscale, '200');\n$color-border-checkbox-hover: map.get($_grayscale, '300');\n$color-border-checkbox-primary: map.get($_grayscale, '200');\n$color-border-divider-normal: map.get($_grayscale, '100');\n$color-border-input-active: map.get($_blue, '600');\n$color-border-input-disable: map.get($_grayscale, '200');\n$color-border-input-error: map.get($_red, '500');\n$color-border-input-hover: map.get($_grayscale, '300');\n$color-border-input-normal: map.get($_grayscale, '200');\n$color-brand-promsy-black: map.get($_grayscale, '900');\n$color-brand-promsy-blue: map.get($_blue, '500');\n$color-brand-promsy-white: map.get($_white, '900');\n$color-icon-primary-disabled: map.get($_grayscale, '200');\n$color-icon-primary-hover: map.get($_grayscale, '600');\n$color-icon-primary-normal: map.get($_grayscale, '400');\n$color-icon-accent-blue: map.get($_blue, '500');\n$color-icon-accent-blue-disabled: map.get($_grayscale, '200');\n$color-icon-accent-blue-hover: map.get($_blue, '600');\n$color-icon-accent-green: map.get($_green, '700');\n$color-icon-accent-grey: map.get($_grayscale, '700');\n$color-icon-accent-orange: map.get($_orange, '700');\n$color-icon-accent-purple: map.get($_purple, '700');\n$color-icon-accent-red: map.get($_red, '700');\n$color-icon-accent-yellow: map.get($_yellow, '700');\n$color-icon-button-primary-disabled: map.get($_grayscale, '200');\n$color-icon-button-primary-hover: map.get($_white, '900');\n$color-icon-button-primary-normal: map.get($_white, '900');\n$color-icon-button-secondary-disabled: map.get($_grayscale, '200');\n$color-icon-button-secondary-hover: map.get($_grayscale, '400');\n$color-icon-button-secondary-normal: map.get($_grayscale, '400');\n$color-icon-checkbox-checked: map.get($_blue, '500');\n$color-icon-checkbox-checked-disabled: map.get($_grayscale, '200');\n$color-icon-fill-black: map.get($_grayscale, '900');\n$color-icon-fill-blue: map.get($_blue, '300');\n$color-icon-fill-green: map.get($_green, '600');\n$color-icon-fill-grey: map.get($_grayscale, '500');\n$color-icon-fill-orange: map.get($_orange, '500');\n$color-icon-fill-promsy: map.get($_blue, '500');\n$color-icon-fill-purple: map.get($_purple, '500');\n$color-icon-fill-red: map.get($_red, '500');\n$color-icon-fill-white: map.get($_white, '900');\n$color-icon-fill-yellow: map.get($_yellow, '500');\n$color-icon-stat-negative: map.get($_red, '500');\n$color-icon-stat-positive: map.get($_green, '600');\n$color-icon-stat-warning: map.get($_yellow, '800');\n$color-progress-bar-blue: map.get($_blue, '300');\n$color-progress-bar-disabled: map.get($_grayscale, '500');\n$color-progress-bar-green: map.get($_green, '500');\n$color-progress-bar-promsy: map.get($_blue, '500');\n$color-progress-bar-purple: map.get($_purple, '500');\n$color-progress-bar-red: map.get($_red, '500');\n$color-progress-bar-tracker: map.get($_grayscale, '100');\n$color-progress-bar-yellow: map.get($_yellow, '500');\n$color-text-default: map.get($_grayscale, '300');\n$color-text-disable: map.get($_grayscale, '200');\n$color-text-error: map.get($_red, '600');\n$color-text-link: map.get($_blue, '500');\n$color-text-link-hover: map.get($_blue, '700');\n$color-text-primary: map.get($_grayscale, '900');\n$color-text-secondary: map.get($_white, '900');\n$color-text-secondary-disable: map.get($_grayscale, '200');\n$color-text-tertiary: map.get($_blue, '500');\n$color-text-accent-blue: map.get($_blue, '700');\n$color-text-accent-green: map.get($_green, '700');\n$color-text-accent-grey: map.get($_grayscale, '700');\n$color-text-accent-orange: map.get($_orange, '700');\n$color-text-accent-purple: map.get($_purple, '700');\n$color-text-accent-red: map.get($_red, '700');\n$color-text-accent-yellow: map.get($_yellow, '800');\n$color-text-button-link: map.get($_blue, '500');\n$color-text-button-link-hover: map.get($_blue, '700');\n$color-text-button-primary-disabled: map.get($_grayscale, '200');\n$color-text-button-primary-normal: map.get($_grayscale, '900');\n$color-text-button-secondary-disable: map.get($_grayscale, '200');\n$color-text-button-secondary-normal: map.get($_white, '900');\n$color-text-stat-negative: map.get($_red, '500');\n$color-text-stat-positive: map.get($_green, '600');\n$color-text-stat-warning: map.get($_yellow, '800');\n$surface-black: map.get($_grayscale, '900');\n$surface-default: map.get($_grayscale, '50');\n$surface-white: map.get($_white, '900');\n","@use \"displayed\" as s;\n@use \"colors\" as c;\n@use \"sass:map\";\n\n$browser-context: 16;\n\n$font-family-inter: 'Inter', sans-serif;\n\n$font_weight_thin: 100;\n$font_weight_light: 300;\n$font_weight_regular: 400;\n$font_weight_medium: 500;\n$font_weight_semi_bold: 600;\n$font_weight_bold: 700;\n$font_weight_black: 900;\n\n//DOCS: Fonts sizes are in rem\n$font-size-12: (\n  'font-size': 0.75,\n  'line-height': 1.125\n);\n\n$font-size-12-alt: (\n  'font-size': 0.75,\n  'line-height': 1\n);\n$font-size-14: (\n  'font-size': .875,\n  'line-height': 1.25\n);\n\n$font-size-16: (\n  'font-size': 1,\n  'line-height': 1.5\n);\n\n$font-size-20: (\n  'font-size': 1.25,\n  'line-height': 1.5\n);\n$font-size-24: (\n  'font-size': 1.5,\n  'line-height': 1.75\n);\n$font-size-32: (\n  'font-size': 2,\n  'line-height': 2.5\n);\n\n$font-size-40: (\n  'font-size': 2.5,\n  'line-height': 3\n);\n\n$font-size-48: (\n  'font-size': 3,\n  'line-height': 3.5\n);\n\n$font-size-60: (\n  'font-size': 3.75,\n  'line-height': 4.5\n);\n\n\n@mixin responsive-font-format(\n  $font-weight: $font-weight-regular,\n  $font-size: $font-size-12,\n  $color: c.$color-brand-promsy-black) {\n  &, & * {\n    @include _responsive-font-size($font-size);\n    color: $color;\n    font-weight: $font-weight;\n  }\n}\n\n/// Apply font-size property with media queries\n///\n/// @param {map} $font-size-map\n///   A map with font-size property for each breakpoint.\n/// @return {number} `The measure in rem`.\n@mixin _responsive-font-size($font-size-map) {\n  @each $property, $value in $font-size-map {\n    #{$property}: $value * 1rem;\n  }\n}\n\n@mixin media-query($breakpoint-name) {\n  @if map-has-key(s.$breakpoints-pqf, $breakpoint-name) {\n    @media (min-width: map.get(s.$breakpoints-pqf, $breakpoint-name)) {\n      @content;\n    }\n  } @else {\n    @warn \"Size doesn't exist `#{$breakpoint-name}`. \"+\"in breakpoints list, check map `$breakpoints`.\";\n  }\n}\n\n@mixin multiLineTextTruncateSinHeight(\n  $lines: 2,\n  //DOCS: Uncomment if you need it\n  //$lineHeight: 1.5em,\n  //$bgcolor: rgba(255, 255, 255, 1),\n  //$transColor: rgba(25, 255, 255, 0)\n) {\n  @supports (-webkit-line-clamp: $lines) {\n    display: block;\n    display: -webkit-box !important;\n    //DOCS: Uncomment if you need it\n    //line-height: $lineHeight;\n    -webkit-line-clamp: $lines;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    word-break: break-all;\n  }\n  @supports not (-webkit-line-clamp: $lines) {\n    position: relative;\n    //DOCS: Uncomment if you need it\n    //line-height: $lineHeight;\n    overflow: hidden;\n    width: 100%;\n    word-break: break-all;\n    &:before {\n      content: '\\00a0\\00a0\\00a0\\00a0\\00a0\\00a0\\00a0\\00a0';\n      position: absolute;\n      bottom: 0;\n      right: 0;\n      //DOCS: Uncomment if you need it\n      //background: transparent linear-gradient(to right, $transColor, $bgcolor 50%) repeat scroll 0% 0%;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
